import { getPlatformAreas } from '@/services/platformApi/publicCatalogApi';

export interface AreaData {
  id: string;
  name: string;
  territory: string;
}

/**
 * Fetch all areas serviced ordered by territory and name
 */
export async function getAllAreas(): Promise<AreaData[]> {
  return getPlatformAreas();
}
